import { render, staticRenderFns } from "./SettingStaking.vue?vue&type=template&id=b543f19c&"
import script from "./SettingStaking.vue?vue&type=script&lang=js&"
export * from "./SettingStaking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports